import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { UserService } from './users.service';

@Injectable()
export class RoleGuard implements CanActivate {

  constructor(private userService: UserService) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    var roles = route.data.roles;
    if (this.userService.isHasRoles(roles)) {
      return true;
    } else {
      this.userService.logout();
      return false;
    }
  }
}
